//export * from '';
import { DynamicHotelListingEditable } from './organisms/RegionCardsWrapper';
export { DynamicHotelListingEditable };
